// SiteStatusPanel.jsx
import React from "react";
import CollapsibleSection from "./CollapsibleSection";

const SiteStatusPanel = ({ isOpen, onToggle, siteStatus, handleSiteStatus, disabled = false }) => {
    return (
        <CollapsibleSection title="📡 Site Status" isOpen={isOpen} onToggle={onToggle}>
            <div className="form-status-bar">
                <select
                    id="site-status"
                    className="status-dropdown"
                    value={siteStatus ?? "Paused"}
                    onChange={(e) => handleSiteStatus(e.target.value)}
                    disabled={disabled}
                    aria-label="Site status"
                >
                    <option value="Paused">Paused</option>
                    <option value="Published">Published</option>
                </select>
            </div>
        </CollapsibleSection>
    );
};

export default SiteStatusPanel;